"use client"

import { GalleryVerticalEnd } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `GalleryVerticalEndIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const GalleryVerticalEndIcon = component(Icon)({
  as: GalleryVerticalEnd,
})
